import {
  Box,
  Heading,
  Icon,
  Spacer,
  useColorModeValue,
  Flex, ButtonGroup,
  createIcon,
  HStack,
  VStack,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useColorMode,
  Select,
  Center,
  theme,
  Tooltip
} from '@chakra-ui/react';


import React from 'react';
import { MdGroupWork } from 'react-icons/md';
import { useState, useEffect } from 'react';
import { TbLocation, TbLocationOff } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import Transcripts from '../components/widgets/TranscriptsWidget';
import NewsWidget from '../components/widgets/NewsWidget';
import TimeTable from '../components/widgets/TimetableWidget';
import Printing from '../components/widgets/PrintingWidget';
import BookLibrary from '../components/widgets/BookLibraryWidget';
import NearestBusStop from '../components/widgets/NearestBusStopWidget';
import CampusEvents from '../components/widgets/CampusEventsWidget';
import ContactLibrary from '../components/widgets/ContactLibraryWidget';
import WeatherWidget from '../components/widgets/WeatherWidget';
import ExamTimetable from '../components/widgets/ExamTimetable';
import Finance from '../components/widgets/Finance';
import LancasterTab from '../components/widgets/LancasterTabWidget';
import LectureCheckIn from '../components/widgets/LectureCheckInWidget';
import Modules from '../components/widgets/ModulesWidget';

import ViewportSensorIntegration from '../components/widgets/ViewportSensorIntegration';

import { DataStore } from '@aws-amplify/datastore';
import { User } from '../models';

import { Auth } from 'aws-amplify';
import { get } from 'lodash';
import PendleRooms from '../components/widgets/PendleRooms';
import Costa from '../components/widgets/Costa';
import Central from '../components/widgets/Central';
import Spar from '../components/widgets/Spar';

const TagBox = ({ selected, tag, bg, collegeColor, setSelectedTag }) => {

  const textColor = useColorModeValue("black", "white");


  return (
    <Box
      w='max-content'
      h='32px'
      bg={selected ? "linear-gradient(100.1deg, #F35C5D -1.42%, #BF1226 95.55%)" : bg}
      px={3}
      py={2}
      borderRadius='30px'
      alignItems='center'
      justifyContent='center'
      borderWidth={selected ? 0 : 1}
      borderColor={"#727272"}
      onClick={() => setSelectedTag(tag)}
    >
      <Text fontSize='sm' fontWeight='normal' mt={-1} color={selected ? "white" : textColor}>{tag}</Text>
    </Box>
  );
};

export const sparkles = createIcon({
  fillColor: { light: 'black', dark: 'white' },
  displayName: 'sparkles',
  viewBox: '0 0 30 30',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <path
      d='M16.25 20C16.0834 20.0002 15.9206 19.9504 15.7826 19.8571C15.6446 19.7638 15.5378 19.6313 15.4758 19.4767L14.7725 17.7159L13.0091 16.9734C12.8579 16.9066 12.7297 16.7966 12.6408 16.6572C12.5518 16.5178 12.506 16.3552 12.5091 16.1899C12.5123 16.0246 12.5641 15.8639 12.6583 15.7279C12.7524 15.592 12.8846 15.4869 13.0383 15.4259L14.7783 14.7667L15.4758 13.0234C15.54 12.871 15.6476 12.741 15.7853 12.6496C15.923 12.5581 16.0847 12.5094 16.25 12.5094C16.4153 12.5094 16.5769 12.5581 16.7146 12.6496C16.8523 12.741 16.96 12.871 17.0241 13.0234L17.725 14.7734L19.475 15.4742C19.6276 15.5381 19.758 15.6456 19.8497 15.7834C19.9414 15.9211 19.9903 16.0829 19.9903 16.2484C19.9903 16.4138 19.9414 16.5756 19.8497 16.7134C19.758 16.8511 19.6276 16.9587 19.475 17.0225L17.725 17.7234L17.0241 19.4734C16.9627 19.6286 16.8561 19.7618 16.718 19.8557C16.58 19.9496 16.4169 19.9999 16.25 20ZM8.3333 17.5C7.97328 17.5044 7.62154 17.392 7.33071 17.1797C7.03989 16.9675 6.82562 16.6667 6.71997 16.3225L5.37497 12.1167L1.1558 10.705C0.815272 10.5912 0.519735 10.3721 0.311876 10.0793C0.104018 9.78657 -0.00540233 9.43531 -0.000579579 9.07629C0.00424318 8.71728 0.123059 8.36908 0.338707 8.08201C0.554355 7.79493 0.855671 7.58383 1.19914 7.4792L5.38497 6.20087L6.79497 1.9892C6.89981 1.64326 7.11666 1.34198 7.41143 1.13275C7.70619 0.923517 8.06215 0.818202 8.4233 0.833368C8.78339 0.833856 9.13363 0.950947 9.4216 1.16712C9.70958 1.38329 9.9198 1.68691 10.0208 2.03253L11.2975 6.2117L15.4891 7.55337C15.8272 7.66677 16.1212 7.88352 16.3294 8.17301C16.5376 8.4625 16.6497 8.81009 16.6497 9.1667C16.6497 9.52331 16.5376 9.8709 16.3294 10.1604C16.1212 10.4499 15.8272 10.6666 15.4891 10.78L11.29 12.1234L9.94664 16.3225C9.84099 16.6667 9.62672 16.9675 9.33589 17.1797C9.04507 17.392 8.69333 17.5044 8.3333 17.5ZM8.42664 2.5192L6.8333 7.1367C6.79129 7.26274 6.71976 7.3769 6.62467 7.46968C6.52957 7.56245 6.41367 7.63115 6.28664 7.67003L1.6858 9.07337L6.3033 10.6709C6.42753 10.7123 6.54026 10.7823 6.63234 10.8754C6.72442 10.9685 6.79327 11.082 6.8333 11.2067L8.3083 15.815L9.8333 11.2067C9.87376 11.0802 9.94387 10.9651 10.0378 10.8712C10.1317 10.7773 10.2468 10.7072 10.3733 10.6667L14.9816 9.19253C14.9875 9.1909 14.9932 9.18837 14.9983 9.18503L10.3733 7.6667C10.245 7.62566 10.1285 7.5541 10.0338 7.45816C9.9392 7.36223 9.86925 7.24477 9.82997 7.11587L8.42664 2.5192ZM17.0833 5.83337C16.8975 5.83336 16.7171 5.77128 16.5706 5.65699C16.4242 5.54269 16.3201 5.38274 16.275 5.20253L15.9775 4.01087L14.7833 3.69003C14.6038 3.64181 14.4456 3.53497 14.3338 3.38651C14.222 3.23804 14.1631 3.05646 14.1663 2.87064C14.1696 2.68482 14.2349 2.50542 14.3518 2.36096C14.4687 2.2165 14.6306 2.11527 14.8116 2.07337L15.9783 1.80253L16.275 0.630868C16.3201 0.450679 16.4242 0.290744 16.5707 0.176467C16.7171 0.0621898 16.8975 0.00012207 17.0833 0.00012207C17.2691 0.00012207 17.4495 0.0621898 17.596 0.176467C17.7424 0.290744 17.8465 0.450679 17.8916 0.630868L18.1866 1.81253L19.3683 2.10837C19.5485 2.15353 19.7084 2.2576 19.8227 2.40405C19.937 2.5505 19.9991 2.73094 19.9991 2.9167C19.9991 3.10246 19.937 3.2829 19.8227 3.42935C19.7084 3.5758 19.5485 3.67987 19.3683 3.72503L18.1866 4.02087L17.8916 5.20253C17.8465 5.38274 17.7424 5.54269 17.596 5.65699C17.4495 5.77128 17.2691 5.83336 17.0833 5.83337Z'
      fill='currentColor'
    />
  ),
})

export const lens = createIcon({
  fillColor: { light: 'black', dark: 'white' },
  displayName: 'lens',
  viewBox: '0 0 30 30',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <>
      <path d="M20.8304 14.4977C20.7114 14.4976 20.5935 14.521 20.4836 14.5666C20.3737 14.6121 20.2738 14.6789 20.1896 14.763C20.1055 14.8472 20.0388 14.9472 19.9933 15.0572C19.9477 15.1671 19.9244 15.285 19.9244 15.4041V17.216C19.9244 17.937 19.6382 18.6284 19.1286 19.1382C18.6191 19.648 17.928 19.9344 17.2074 19.9344H15.3964C15.2758 19.9318 15.1559 19.9533 15.0437 19.9977C14.9315 20.042 14.8294 20.1084 14.7431 20.1928C14.6569 20.2772 14.5884 20.378 14.5417 20.4892C14.4949 20.6004 14.4708 20.7199 14.4708 20.8406C14.4708 20.9613 14.4949 21.0807 14.5417 21.192C14.5884 21.3032 14.6569 21.404 14.7431 21.4884C14.8294 21.5728 14.9315 21.6392 15.0437 21.6835C15.1559 21.7279 15.2758 21.7494 15.3964 21.7468H17.2074C18.408 21.7453 19.559 21.2675 20.4079 20.4181C21.2568 19.5688 21.7344 18.4172 21.7359 17.216V15.4041C21.7359 15.2851 21.7125 15.1672 21.6671 15.0573C21.6216 14.9473 21.5549 14.8474 21.4708 14.7632C21.3867 14.679 21.2869 14.6122 21.177 14.5667C21.0671 14.5211 20.9493 14.4977 20.8304 14.4977V14.4977Z"
        fill="currentColor" />
      <path d="M0.905525 7.24825C1.02451 7.24831 1.14234 7.2249 1.25228 7.17937C1.36222 7.13384 1.46212 7.06708 1.54625 6.9829C1.63039 6.89872 1.69712 6.79877 1.74263 6.68878C1.78814 6.57878 1.81153 6.46089 1.81148 6.34184V4.52988C1.81148 3.80892 2.09773 3.11749 2.60727 2.6077C3.1168 2.0979 3.80788 1.8115 4.52848 1.8115H6.33953C6.46012 1.81412 6.58002 1.79261 6.69219 1.74824C6.80437 1.70387 6.90656 1.63754 6.99277 1.55314C7.07898 1.46873 7.14747 1.36795 7.19424 1.2567C7.241 1.14546 7.26509 1.02599 7.26509 0.905309C7.26509 0.784627 7.241 0.665159 7.19424 0.553915C7.14747 0.442671 7.07898 0.341889 6.99277 0.257482C6.90656 0.173076 6.80437 0.106743 6.69219 0.0623765C6.58002 0.0180096 6.46012 -0.00349853 6.33953 -0.000886245H4.52848C3.3279 0.000574984 2.17691 0.478391 1.32797 1.32776C0.479035 2.17712 0.00146059 3.32869 9.95242e-08 4.52988V6.34184C-5.56675e-05 6.46086 0.0233253 6.57871 0.0688072 6.68868C0.114289 6.79865 0.180981 6.89857 0.265072 6.98275C0.349163 7.06692 0.449007 7.13369 0.558898 7.17925C0.668789 7.2248 0.786574 7.24825 0.905525 7.24825V7.24825Z"
        fill="currentColor" />
      <path d="M6.33937 19.9345H4.52832C3.80773 19.9345 3.11665 19.6481 2.60711 19.1383C2.09758 18.6285 1.81132 17.9371 1.81132 17.2161V15.4042C1.81393 15.2835 1.79243 15.1636 1.74809 15.0513C1.70375 14.9391 1.63745 14.8369 1.55308 14.7506C1.46872 14.6643 1.36799 14.5958 1.2568 14.549C1.14561 14.5022 1.0262 14.4781 0.905584 14.4781C0.784962 14.4781 0.665555 14.5022 0.554367 14.549C0.443179 14.5958 0.342448 14.6643 0.258084 14.7506C0.17372 14.8369 0.107421 14.9391 0.0630769 15.0513C0.0187324 15.1636 -0.0027649 15.2835 -0.000153931 15.4042V17.2161C0.00130656 18.4173 0.478881 19.5689 1.32782 20.4182C2.17676 21.2676 3.32774 21.7454 4.52832 21.7469H6.33937C6.45997 21.7495 6.57987 21.728 6.69204 21.6836C6.80421 21.6392 6.9064 21.5729 6.99261 21.4885C7.07882 21.4041 7.14732 21.3033 7.19408 21.1921C7.24084 21.0808 7.26493 20.9614 7.26493 20.8407C7.26493 20.72 7.24084 20.6005 7.19408 20.4893C7.14732 20.378 7.07882 20.2773 6.99261 20.1929C6.9064 20.1085 6.80421 20.0421 6.69204 19.9978C6.57987 19.9534 6.45997 19.9319 6.33937 19.9345V19.9345Z"
        fill="currentColor" />
      <path d="M17.2074 -0.000153823H15.3964C15.2758 -0.00276611 15.1559 0.018742 15.0437 0.063109C14.9315 0.107476 14.8294 0.173808 14.7431 0.258215C14.6569 0.342622 14.5884 0.443403 14.5417 0.554647C14.4949 0.665892 14.4708 0.785359 14.4708 0.906042C14.4708 1.02672 14.4949 1.14619 14.5417 1.25744C14.5884 1.36868 14.6569 1.46946 14.7431 1.55387C14.8294 1.63828 14.9315 1.70461 15.0437 1.74897C15.1559 1.79334 15.2758 1.81485 15.3964 1.81224H17.2074C17.928 1.81224 18.6191 2.09864 19.1286 2.60843C19.6382 3.11822 19.9244 3.80965 19.9244 4.53061V6.34258C19.9218 6.46323 19.9433 6.58319 19.9876 6.69542C20.032 6.80765 20.0983 6.9099 20.1826 6.99615C20.267 7.0824 20.3677 7.15093 20.4789 7.19772C20.5901 7.2445 20.7095 7.2686 20.8301 7.2686C20.9508 7.2686 21.0702 7.2445 21.1814 7.19772C21.2925 7.15093 21.3933 7.0824 21.4776 6.99615C21.562 6.9099 21.6283 6.80765 21.6726 6.69542C21.717 6.58319 21.7385 6.46323 21.7359 6.34258V4.53061C21.7344 3.32943 21.2568 2.17786 20.4079 1.32849C19.559 0.479124 18.408 0.00130741 17.2074 -0.000153823V-0.000153823Z"
        fill="currentColor" />
      <path d="M10.8681 15.2107C11.7255 15.2107 12.5636 14.9563 13.2764 14.4797C13.9893 14.0032 14.5449 13.3258 14.873 12.5333C15.2011 11.7408 15.287 10.8688 15.1197 10.0275C14.9524 9.18615 14.5396 8.41335 13.9333 7.8068C13.3271 7.20025 12.5547 6.78718 11.7138 6.61984C10.8729 6.45249 10.0013 6.53838 9.20921 6.86664C8.41711 7.1949 7.74009 7.7508 7.26376 8.46403C6.78744 9.17726 6.5332 10.0158 6.5332 10.8736C6.5332 12.0238 6.98991 13.127 7.80287 13.9404C8.61582 14.7537 9.71841 15.2107 10.8681 15.2107V15.2107ZM10.8681 8.70738C11.2969 8.70696 11.7162 8.83382 12.073 9.07192C12.4297 9.31002 12.7078 9.64864 12.8721 10.0449C13.0364 10.4412 13.0795 10.8774 12.9959 11.2982C12.9124 11.719 12.7059 12.1056 12.4027 12.4089C12.0995 12.7123 11.7131 12.9189 11.2925 13.0025C10.8719 13.0861 10.436 13.0429 10.0399 12.8786C9.64378 12.7142 9.30533 12.4359 9.06735 12.079C8.82937 11.7221 8.70257 11.3026 8.70299 10.8736C8.70299 10.2991 8.9311 9.74809 9.33713 9.34184C9.74317 8.9356 10.2939 8.70738 10.8681 8.70738V8.70738Z"
        fill="currentColor" />
    </>
  ),
})

export const idCard = createIcon({
  fillColor: { light: 'black', dark: 'white' },
  displayName: 'idCard',
  viewBox: '0 0 30 30',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <>
      <path d='M15.8333 3.33333H12.5V2.5C12.5 1.83696 12.2366 1.20107 11.7678 0.732233C11.2989 0.263392 10.663 0 10 0C9.33696 0 8.70107 0.263392 8.23223 0.732233C7.76339 1.20107 7.5 1.83696 7.5 2.5V3.33333H4.16667C3.062 3.33466 2.00296 3.77407 1.22185 4.55518C0.440735 5.3363 0.00132321 6.39534 0 7.5L0 15.8333C0.00132321 16.938 0.440735 17.997 1.22185 18.7782C2.00296 19.5593 3.062 19.9987 4.16667 20H15.8333C16.938 19.9987 17.997 19.5593 18.7782 18.7782C19.5593 17.997 19.9987 16.938 20 15.8333V7.5C19.9987 6.39534 19.5593 5.3363 18.7782 4.55518C17.997 3.77407 16.938 3.33466 15.8333 3.33333ZM9.16667 2.5C9.16667 2.27899 9.25446 2.06702 9.41074 1.91074C9.56703 1.75446 9.77899 1.66667 10 1.66667C10.221 1.66667 10.433 1.75446 10.5893 1.91074C10.7455 2.06702 10.8333 2.27899 10.8333 2.5V4.16667C10.8333 4.38768 10.7455 4.59964 10.5893 4.75592C10.433 4.9122 10.221 5 10 5C9.77899 5 9.56703 4.9122 9.41074 4.75592C9.25446 4.59964 9.16667 4.38768 9.16667 4.16667V2.5ZM18.3333 15.8333C18.3333 16.4964 18.0699 17.1323 17.6011 17.6011C17.1323 18.0699 16.4964 18.3333 15.8333 18.3333H4.16667C3.50363 18.3333 2.86774 18.0699 2.3989 17.6011C1.93006 17.1323 1.66667 16.4964 1.66667 15.8333V7.5C1.66667 6.83696 1.93006 6.20107 2.3989 5.73223C2.86774 5.26339 3.50363 5 4.16667 5H7.65333C7.82304 5.48712 8.14013 5.90936 8.56062 6.20814C8.98111 6.50693 9.48416 6.66745 10 6.66745C10.5158 6.66745 11.0189 6.50693 11.4394 6.20814C11.8599 5.90936 12.177 5.48712 12.3467 5H15.8333C16.4964 5 17.1323 5.26339 17.6011 5.73223C18.0699 6.20107 18.3333 6.83696 18.3333 7.5V15.8333ZM8.33333 8.33333H4.16667C3.94565 8.33333 3.73369 8.42113 3.57741 8.57741C3.42113 8.73369 3.33333 8.94565 3.33333 9.16667V15.8333C3.33333 16.0543 3.42113 16.2663 3.57741 16.4226C3.73369 16.5789 3.94565 16.6667 4.16667 16.6667H8.33333C8.55435 16.6667 8.76631 16.5789 8.92259 16.4226C9.07887 16.2663 9.16667 16.0543 9.16667 15.8333V9.16667C9.16667 8.94565 9.07887 8.73369 8.92259 8.57741C8.76631 8.42113 8.55435 8.33333 8.33333 8.33333ZM7.5 15H5V10H7.5V15ZM16.6667 12.5C16.6667 12.721 16.5789 12.933 16.4226 13.0893C16.2663 13.2455 16.0543 13.3333 15.8333 13.3333H11.6667C11.4457 13.3333 11.2337 13.2455 11.0774 13.0893C10.9211 12.933 10.8333 12.721 10.8333 12.5C10.8333 12.279 10.9211 12.067 11.0774 11.9107C11.2337 11.7545 11.4457 11.6667 11.6667 11.6667H15.8333C16.0543 11.6667 16.2663 11.7545 16.4226 11.9107C16.5789 12.067 16.6667 12.279 16.6667 12.5ZM16.6667 9.16667C16.6667 9.38768 16.5789 9.59964 16.4226 9.75592C16.2663 9.9122 16.0543 10 15.8333 10H11.6667C11.4457 10 11.2337 9.9122 11.0774 9.75592C10.9211 9.59964 10.8333 9.38768 10.8333 9.16667C10.8333 8.94565 10.9211 8.73369 11.0774 8.57741C11.2337 8.42113 11.4457 8.33333 11.6667 8.33333H15.8333C16.0543 8.33333 16.2663 8.42113 16.4226 8.57741C16.5789 8.73369 16.6667 8.94565 16.6667 9.16667ZM15 15.8333C15 16.0543 14.9122 16.2663 14.7559 16.4226C14.5996 16.5789 14.3877 16.6667 14.1667 16.6667H11.6667C11.4457 16.6667 11.2337 16.5789 11.0774 16.4226C10.9211 16.2663 10.8333 16.0543 10.8333 15.8333C10.8333 15.6123 10.9211 15.4004 11.0774 15.2441C11.2337 15.0878 11.4457 15 11.6667 15H14.1667C14.3877 15 14.5996 15.0878 14.7559 15.2441C14.9122 15.4004 15 15.6123 15 15.8333Z'
        fill="currentColor"
      />
    </>
  ),
})

export const sun = createIcon({
  fillColor: { light: 'black', dark: 'white' },
  displayName: 'sun',
  viewBox: '0 0 30 30',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <>
      <path d="M10 14.1667C7.7 14.1667 5.83333 12.3 5.83333 10C5.83333 7.7 7.7 5.83333 10 5.83333C12.3 5.83333 14.1667 7.7 14.1667 10C14.1667 12.3 12.3 14.1667 10 14.1667ZM10 7.5C8.625 7.5 7.5 8.625 7.5 10C7.5 11.375 8.625 12.5 10 12.5C11.375 12.5 12.5 11.375 12.5 10C12.5 8.625 11.375 7.5 10 7.5ZM10.8333 3.33333V0.833333C10.8333 0.375 10.4583 0 10 0C9.54167 0 9.16667 0.375 9.16667 0.833333V3.33333C9.16667 3.79167 9.54167 4.16667 10 4.16667C10.4583 4.16667 10.8333 3.79167 10.8333 3.33333ZM10.8333 19.1667V16.6667C10.8333 16.2083 10.4583 15.8333 10 15.8333C9.54167 15.8333 9.16667 16.2083 9.16667 16.6667V19.1667C9.16667 19.625 9.54167 20 10 20C10.4583 20 10.8333 19.625 10.8333 19.1667ZM4.16667 10C4.16667 9.54167 3.79167 9.16667 3.33333 9.16667H0.833333C0.375 9.16667 0 9.54167 0 10C0 10.4583 0.375 10.8333 0.833333 10.8333H3.33333C3.79167 10.8333 4.16667 10.4583 4.16667 10ZM20 10C20 9.54167 19.625 9.16667 19.1667 9.16667H16.6667C16.2083 9.16667 15.8333 9.54167 15.8333 10C15.8333 10.4583 16.2083 10.8333 16.6667 10.8333H19.1667C19.625 10.8333 20 10.4583 20 10ZM5.59167 5.59167C5.91667 5.26667 5.91667 4.74167 5.59167 4.41667L3.925 2.75C3.6 2.425 3.075 2.425 2.75 2.75C2.425 3.075 2.425 3.6 2.75 3.925L4.41667 5.59167C4.58333 5.75833 4.79167 5.83333 5.00833 5.83333C5.225 5.83333 5.43333 5.75 5.6 5.59167H5.59167ZM17.2583 17.2583C17.5833 16.9333 17.5833 16.4083 17.2583 16.0833L15.5917 14.4167C15.2667 14.0917 14.7417 14.0917 14.4167 14.4167C14.0917 14.7417 14.0917 15.2667 14.4167 15.5917L16.0833 17.2583C16.25 17.425 16.4583 17.5 16.675 17.5C16.8917 17.5 17.1 17.4167 17.2667 17.2583H17.2583ZM3.925 17.2583L5.59167 15.5917C5.91667 15.2667 5.91667 14.7417 5.59167 14.4167C5.26667 14.0917 4.74167 14.0917 4.41667 14.4167L2.75 16.0833C2.425 16.4083 2.425 16.9333 2.75 17.2583C2.91667 17.425 3.125 17.5 3.34167 17.5C3.55833 17.5 3.76667 17.4167 3.93333 17.2583H3.925ZM15.5917 5.59167L17.2583 3.925C17.5833 3.6 17.5833 3.075 17.2583 2.75C16.9333 2.425 16.4083 2.425 16.0833 2.75L14.4167 4.41667C14.0917 4.74167 14.0917 5.26667 14.4167 5.59167C14.5833 5.75833 14.7917 5.83333 15.0083 5.83333C15.225 5.83333 15.4333 5.75 15.6 5.59167H15.5917Z"
        fill="currentColor" />
    </>
  ),
})

export const moon = createIcon({
  fillColor: { light: 'black', dark: 'white' },
  displayName: 'moon',
  viewBox: '0 0 30 30',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <>
      <path d="M10.0136 19.9668C4.50914 19.9819 0.0346083 15.5318 0.0195693 10.0273C0.00453019 4.52281 4.45457 0.0482794 9.9591 0.0332403C11.6609 0.0285919 13.3355 0.459764 14.8235 1.28566L16.1134 2.0016L14.831 2.7325C11.0462 4.88144 9.72023 9.69164 11.8692 13.4764C12.6965 14.9334 13.9667 16.0889 15.4954 16.775L16.8418 17.3821L15.6234 18.2127C13.9742 19.352 12.018 19.9637 10.0136 19.9668ZM10.0136 1.6943C5.42652 1.6943 1.70793 5.41289 1.70793 10C1.70793 14.5871 5.42652 18.3057 10.0136 18.3057C11.2058 18.3059 12.3836 18.0457 13.4646 17.5432C9.06976 14.6414 7.85945 8.72625 10.7613 4.33137C11.3038 3.50972 11.9703 2.77707 12.7371 2.15945C11.8625 1.84984 10.9414 1.6925 10.0136 1.6943ZM16.0768 8.08969L17.0461 10.0274L18.0162 8.08969L19.9539 7.12043L18.0162 6.15031L17.0469 4.21258L16.0768 6.15031L14.1399 7.11957L16.0768 8.08969ZM19.1499 14.1528C18.6912 14.1528 18.3193 14.5247 18.3193 14.9834C18.3193 15.4421 18.6912 15.814 19.1499 15.814C19.6086 15.814 19.9805 15.4421 19.9805 14.9834C19.9805 14.5247 19.6086 14.1528 19.1499 14.1528ZM14.1665 10.8306C13.7078 10.8306 13.3359 11.2025 13.3359 11.6612C13.3359 12.1199 13.7078 12.4918 14.1665 12.4918C14.6252 12.4918 14.9971 12.1199 14.9971 11.6612C14.9971 11.2025 14.6252 10.8306 14.1665 10.8306Z"
        fill="currentColor" />
    </>
  ),
})

async function getSuggestedWidgets() {
  const models = await DataStore.query(User);
  const userID = await Auth.currentAuthenticatedUser().then(user => user.attributes.sub);

  const filteredUser = models.filter(model => model.userSub === userID);
  console.log(filteredUser);

  const suggestedWidgets = filteredUser.length > 0 ? filteredUser[0].suggestedWidgets : null;

  return suggestedWidgets ?? []; // If suggestedWidgets is null or undefined, return an empty array instead.
}


function Today(user) {

  const [widgets, setWidgets] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const data = await getSuggestedWidgets();
      setWidgets(data);
    }
    fetchData();
  }, []);

  const [position, setPosition] = useState({});

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      position => setPosition(position.coords),
      err => console.error(err)
    );
  }, []);

  var given_name = user.user.attributes.given_name;
  var college = user.user.attributes['custom:college'];

  const bg = useColorModeValue("white", "black");
  const iconColor = useColorModeValue("black", "white");
  const { colorMode, toggleColorMode } = useColorMode()

  const [selectedTag, setSelectedTag] = useState('Overview');

  // data structure to store a list of tags
  const tags = [
    'Overview',
    'Academic',
    'Productivity',
    'Transport',
    'Social',
    'Finance',
  ]

  // data structure to store college and its respective colour
  const collegeColor = {
    'Grizedale': '#00529b',
    'Bowland': '#e24140',
    'Cartmel': '#7c003c',
    'County': '#013668',
    'Furness': '#343092',
    'Fylde': '#f47b20',
    'Graduate': '#b20e0f',
    'Lonsdale': '#383278',
    'Pendle': '#feb914',
  }

  // function that retruns date as Thursday 13 October
  const getDay = () => {
    var date = new Date();
    const day = new Date(date).toLocaleString('en-GB', { weekday: 'long' })
    const dayNum = new Date(date).toLocaleString('en-GB', { day: 'numeric' })
    const month = new Date(date).toLocaleString('en-GB', { month: 'long' })
    return `${day} ${dayNum} ${month}`
  }




  // return a set of widgets based on the selected tag
  const getWidgets = () => {

    const algorithm = user.user.attributes['custom:algorithm']

    const sessionContext = {
      user: user.user,
      position: position,
      sessionDuration: sessionDuration,
    };

    if (selectedTag === 'Overview') {
      switch (algorithm) {
        case 'Classic':

          return (
            <>
              <BookLibrary sessionContext={SessionContext} />
              <Costa sessionContext={SessionContext} />
              <ExamTimetable sessionContext={SessionContext} />
              <LectureCheckIn sessionContext={SessionContext} />
              <Modules sessionContext={SessionContext} />
              <Printing sessionContext={SessionContext} />
              <TimeTable sessionContext={SessionContext} />
              <ContactLibrary sessionContext={SessionContext} />
              <Transcripts sessionContext={SessionContext} />
            </>
          )

        case 'Suggested':

          return (
            <>
              <PendleRooms sessionContext={SessionContext} />
              <BookLibrary sessionContext={SessionContext} />
              <LectureCheckIn sessionContext={SessionContext} />
              <Modules sessionContext={SessionContext} />
              <Central sessionContext={SessionContext} />
              <TimeTable sessionContext={SessionContext} />
              <Transcripts sessionContext={SessionContext} />
            </>
          )

        default:
          // The default algorithm is used if the user has not selected an algorithm
          return (
            <>
              <BookLibrary sessionContext={SessionContext} />
              <ContactLibrary sessionContext={SessionContext} />
              <ExamTimetable sessionContext={SessionContext} />
              <LectureCheckIn sessionContext={SessionContext} />
              <Modules sessionContext={SessionContext} />
              <Printing sessionContext={SessionContext} />
              <TimeTable sessionContext={SessionContext} />
              <Transcripts sessionContext={SessionContext} />
              <WeatherWidget sessionContext={SessionContext} />
              <CampusEvents sessionContext={SessionContext} />
              <Finance sessionContext={SessionContext} />
              <Spar sessionContext={SessionContext} />
            </>
          )
      }

    } else if (selectedTag === 'Academic') {
      return (
        <>
          <ExamTimetable sessionContext={SessionContext} />
          <LectureCheckIn sessionContext={SessionContext} />
          <Modules sessionContext={SessionContext} />
          <TimeTable sessionContext={SessionContext} />
          <Transcripts sessionContext={SessionContext} />
        </>
      )
    } else if (selectedTag === 'Productivity') {
      return (
        <>
          <BookLibrary sessionContext={SessionContext} />
          <ContactLibrary sessionContext={SessionContext} />
          <Printing sessionContext={SessionContext} />
          <TimeTable sessionContext={SessionContext} />
          <Transcripts sessionContext={SessionContext} />
        </>
      )
    } else if (selectedTag === 'Transport') {
      return (
        <>
          <WeatherWidget sessionContext={SessionContext} />
        </>
      )
    } else if (selectedTag === 'Social') {
      return (
        <>
          <CampusEvents sessionContext={SessionContext} />
          <WeatherWidget sessionContext={SessionContext} />
        </>
      )
    } else if (selectedTag === 'Finance') {
      return (
        <>
          <Finance sessionContext={SessionContext} />
        </>
      )
    } else if (selectedTag === 'Entertainment') {
      return (
        <>
          <LancasterTab sessionContext={SessionContext} />
          <NewsWidget sessionContext={SessionContext} />
        </>
      )
    }
  }

  // create a timer that starts when the page is loaded
  const [sessionDuration, setSessionDuration] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setSessionDuration(sessionDuration => sessionDuration + 1);
    }, 50000);
    return () => clearInterval(timer);
  }, []);

  // create a store the session duration, position and user
  const SessionContext = {
    sessionDuration,
    position,
    user,
  }



  async function setAlgorithm(algorithm) {
    localStorage.setItem('algorithm', algorithm);
    const user = await Auth.currentAuthenticatedUser();
    const attributes = {
      'custom:algorithm': algorithm,
    }
    await Auth.updateUserAttributes(user, attributes);
  }




  async function signOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  function getRefreshTime() {

    let countdown = setInterval(function () {
      let now = new Date();
      let targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0);
      let timeRemaining = targetTime - now;

      if (timeRemaining < 0) {
        clearInterval(countdown);
        console.log("Time's up!");
        return;
      }

      let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      console.log(hours + "h " + minutes + "m " + seconds + "s ");
    }, 1000);

    return countdown;

  }

  return (
    <>
      <Box w='100%' h='100%' bg={bg}>
        <Box
          bg={bg}
          w="100%"
          h="80px"
          px={4}
          pt={4}
        >
          <Flex minWidth='max-content' alignItems='center' gap='0'>
            <Box p='2'>
              <Icon as={lens} w={8} h={8} />
            </Box>
            <Spacer />
            <ButtonGroup gap='2'>
              {/* navigate to personalise */}
              <Link to={'/personalise'}>
                <Icon as={sparkles} w={8} h={8} color={iconColor} />
              </Link>
              <Icon as={idCard} w={8} h={8} />
              <Icon
                as={colorMode === "light" ? moon : sun}
                w={8}
                h={8}
                onClick={toggleColorMode}
              />
            </ButtonGroup>
          </Flex>
        </Box>
        <Flex alignItems='center'>
          <Flex
            mx={5}
            w={"50px"}
            h={"50px"}
            bg={bg}
            borderRadius={"20px"}
            alignItems='center'
            justifyContent='center'
            borderWidth={"3px"}
            borderColor={collegeColor[college]}
          >
            <Flex>
              <Box
                w={"38px"}
                h={"38px"}
                bg={"red.500"}
                borderRadius={"15px"}
              />
            </Flex>
          </Flex>
          <VStack alignItems='flex-start' spacing='0'>
            <Text fontSize='sm' fontWeight='normal' mt={-1}>{getDay()}</Text>
            <Text fontSize='2xl' fontWeight='bold' mt={0}>Hello, {given_name} 👋</Text>
          </VStack>
        </Flex>

        <Flex
          w='100%'
          h='50px'
        >
          <HStack
            overflow={'auto'}
            spacing='2'
            p={4}
            mt={6}
            alignItems='center'
            justifyContent='flex-start'
            decoration='none'
            overflowY={'hidden'}
            css={{
              '&::-webkit-scrollbar': {
                display: 'none'
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'transparent',
                borderRadius: '0px',
              },
            }}
          >
            {tags.map((tag) => (
              <TagBox
                selected={selectedTag === tag}
                tag={tag}
                bg={bg}
                collegeColor={collegeColor['Grizedale']}
                setSelectedTag={setSelectedTag}
              />
            ))}
          </HStack>
        </Flex>

        <HStack mt={10} ml={6} mr={6} >

          <HStack spacing='2'>
            <Heading py={2} size='md' >{selectedTag}</Heading>

            {position.longitude !== undefined && position.latitude !== undefined ? (
              <Tooltip label="Location services enabled" aria-label="Location services enabled" position={'bottom'} >
                <Icon as={TbLocation} w={4} h={4} color={iconColor} />
              </Tooltip>
            ) :
              <Tooltip label="Location services disabled" aria-label="Location services disabled" position={'bottom'} >
                <Icon as={TbLocationOff} w={4} h={4} color={"red.500"} />
              </Tooltip>
            }

          </HStack>

          <Spacer />

          {selectedTag === 'Overview' ? (
            <Select variant='solid' size='sm' maxW={150} rounded='full' color={iconColor} borderColor={'#7F7F7F'} borderWidth={1} bg={bg} onChange={(e) => setAlgorithm(e.target.value)} value={localStorage.getItem('algorithm')}>
              <option value="Suggested">Suggested</option>
              <option value="Classic">Classic</option>
              <option value="default">All widgets</option>
            </Select>
          ) : null}

        </HStack>

        {selectedTag === 'Overview' ? (
          <Text ml={6} mt={2} fontSize='xs' color={"iconColor"}>These widgets are based on your usage. Your widgets will refresh soon.</Text>
        ) : null}

        {selectedTag === 'Overview' && localStorage.getItem('algorithm') === 'Your Usage' ? (
          <Text ml={6} mt={2} fontSize='xs' color={"iconColor"}>Based on your usage, we recommend the following widgets, additionally we are using your location to refine the results</Text>
        ) : null}

        {selectedTag === 'Overview' && localStorage.getItem('algorithm') === 'Recommended' ? (
          <Text ml={6} mt={2} fontSize='xs' color={iconColor}>Based on your usage and what similar users liked, we recommend the following widgets</Text>
        ) : null}

        {selectedTag === 'Overview' && localStorage.getItem('algorithm') === 'Random' ? (
          <Text ml={6} mt={2} fontSize='xs' color={iconColor}>These widgets are selected at random</Text>
        ) : null}

        <VStack
          w='100%'
          h='100%'
          p={6}
          mt={1}
        >
          {getWidgets()}
          {/* <ViewportSensorIntegration /> */}
        </VStack>

        {/* <Center
          w='100%'
          p={4}
        >
          <VStack spacing='2'>
            <Button onClick={signOut}>Sign Out</Button>
            <Button onClick={getSuggestedWidgets}>Get Suggested Widgets</Button>
          </VStack>
        </Center> */}
      </Box>

    </>
  );
}

export default Today;
